<template>
  <transition name="fade">
    <div class="modal" v-if="show" v-on:click="modalClicked">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <h4 v-html="title"></h4>
        <form v-on:submit.prevent="handleSubmit">
          <div class="fieldCnt" :class="{hasError: errorMsg}">
            <textarea class="field" :placeholder="placeholder"
              v-if="['textarea', 'long-textarea'].includes(type)"
              :rows="type === 'long-textarea' ? 12 : 3"
              v-model="field[lang]"></textarea>
            <select class="field" v-else-if="type === 'select'"
              v-model="field[lang]">
              <option v-for="(item, i) in options" :key="`opt${i}`"
                :value="item.value || item">
                {{item.label || item}}
              </option>
            </select>
            <div class="mediaCnt" v-else-if="type === 'media/image'">
              <div class="field" v-on:click="selectMedia">
                <div class="fieldImg" v-if="media[lang]"
                  :style="{'background-image': `url(${media[lang].imageSm})`}"></div>
                <div class="fieldImg noImg" v-else></div>
                <div class="mediaLabel" v-if="media[lang] && media[lang].name">
                  {{media[lang].name}}</div>
                <div class="mediaLabel" v-else-if="media[lang]">
                  Selected Media</div>
                <div class="mediaLabel" v-else>Select Media</div>
                <div class="fieldMore" v-if="media[lang]"
                  v-on:click.stop="removeMedia"></div>
              </div>
            </div>
            <input :type="type" class="field" :placeholder="placeholder"
              v-else v-model="field[lang]">
            <div v-if="type === 'ig'">
              <div class="fieldHint">
                Go to instagram post, and copy embed code then paste here.
              </div>
              <div class="hint">
                <video autoplay loop>
                  <source src="../assets/vid-ig-embed-code.webm">
                </video>
              </div>
            </div>
            <div v-else-if="type === 'tw'">
              <div class="fieldHint">
                In tweet click option icon then click embed tweet.
              </div>
              <div class="hint">
                <video autoplay loop>
                  <source src="../assets/vid-tw-embed-code.webm">
                </video>
              </div>
            </div>
            <div class="fieldHint" v-else-if="helper" v-html="helper"></div>
            <div class="fieldError" v-if="errorMsg">
              {{errorMsg}}
            </div>
          </div>
          <div class="modalAction">
            <div class="langSelectorBtn" v-if="multiLang"
              v-on:click.stop="langSelectorOpen = !langSelectorOpen">
              <b>{{lang}}</b>
              <div class="langSelector" v-if="langSelectorOpen"
                v-on:click.stop="doNothing">
                <li v-on:click="selectLang('en')">EN - English</li>
                <li v-on:click="selectLang('id')">ID - Bahasa Indonesia</li>
              </div>
            </div>
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary" type="submit">
              <span v-if="action">{{action}}</span>
              <span v-else>Insert</span>
            </button>
          </div>
        </form>
      </div>
      <MediaSelector ref="mediaSelector"/>
      <Confirmation ref="confirmDialog"/>
    </div>
  </transition>
</template>

<script>
import MediaSelector from '@/components/MediaSelector.vue';
import Confirmation from '@/components/Confirmation.vue';

export default {
  components: { MediaSelector, Confirmation },
  data() {
    return {
      show: false,
      field: { en: '', id: '' },
      title: '',
      placeholder: '',
      options: [],
      action: '',
      type: 'input',
      helper: '',
      errorMsg: null,
      next: null,
      required: false,
      media: { id: null, en: null },

      /**
       * Language
       *
       */
      lang: 'id',
      multiLang: true,
      langSelectorOpen: false,
    };
  },
  methods: {
    doNothing() {},
    modalClicked() {
      this.langSelectorOpen = false;
    },
    selectMedia() {
      let type = '';
      if (this.type === 'media/image') type = 'image';
      this.$refs.mediaSelector.open({ type }, (b, m) => {
        const media = m.gallery ? m.gallery[0] : m;
        if (this.type === 'media/image' && media.type !== 'image') {
          this.$refs.confirmDialog.open({
            title: 'Media Not Supported',
            desc: 'Only support media type image for this content',
            error: true,
          });
          return;
        }
        this.media[this.lang] = media;
      });
    },
    removeMedia() {
      this.$refs.confirmDialog.open({
        title: 'Remove Media',
        desc: 'Are you sure you want to remove this media for tis language?',
        action: 'Remove Media',
      }, (b) => {
        if (!b) return;
        this.media[this.lang] = null;
      });
    },
    open(d, n) {
      this.title = d.title;
      this.placeholder = d.placeholder;
      this.action = d.action;
      this.type = d.type || 'input';
      this.options = d.options || [];
      if (d.multiLang) {
        if (['media/image'].includes(d.type)) {
          this.media.en = d.model && d.model.en ? d.model.en : null;
          this.media.id = d.model && d.model.id ? d.model.id : null;
        } else {
          this.field.en = d.model && d.model.en ? d.model.en : '';
          this.field.id = d.model && d.model.id ? d.model.id : '';
        }
      } else if (['media/image'].includes(d.type)) {
        this.field.id = d.model || null;
      } else {
        this.field.id = d.model || '';
      }
      if (d.type === 'select' && this.options.length > 0 && !this.field[this.lang]) {
        [this.field[this.lang]] = this.options;
      }
      this.helper = d.helper;
      this.multiLang = d.multiLang;
      this.required = d.required;
      this.lang = 'id';
      this.errorMsg = null;
      this.next = n;
      this.show = true;
    },
    selectLang(lang) {
      this.lang = lang;
      this.langSelectorOpen = false;
    },
    handleSubmit() {
      if (this.required && this.multiLang && (!this.field.en || !this.field.id)) {
        if (this.lang === 'id' && this.field.id) this.lang = 'en';
        this.errorMsg = `Please input ${this.title}`;
      } else if (this.required && !this.field.id) {
        this.errorMsg = `Please input ${this.title}`;
      } else if (this.multiLang && ['media/image'].includes(this.type)) {
        this.close(true, this.media);
      } else if (this.multiLang) {
        this.close(true, this.field);
      } else {
        this.close(true, this.field.id);
      }
    },
    close(b, val) {
      this.show = false;
      const v = (val) ? JSON.parse(JSON.stringify(val)) : null;
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.5);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      max-width: none;
      width: 440px;
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .hint{
        color: #767676;
        font-size: 14px;
        margin-top: 6px;
        video{
          width: 100%;
          border-radius: 5px;
          margin-top: 10px;
        }
      }
      .mediaCnt{
        .field{
          cursor: pointer;
          padding: 18px 40px 19px;
          padding-left: 64px;
          position: relative;
          .mediaLabel{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: 600;
            font-size: 17px;
          }
          .fieldImg{
            content: "";
            position: absolute;
            width: 46px; height: 46px;
            background-color: #ccc;
            border-radius: 5px;
            left: 6px; top: 6px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            &.noImg{
              background-image: url(../assets/image-black.png);
              background-size: 24px auto;
              opacity: .36;
            }
          }
          .fieldMore{
            position: absolute;
            right: 8px; top: 11px;
            width: 34px; height: 34px;
            border-radius: 50%;
            background-size: 12px auto;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(../assets/close.png);
            opacity: .36;
            cursor: pointer;
            transition: all .3s ease;
            &:hover{
              background-color: #ccc;
              opacity: .64;
            }
          }
        }
      }
      .modalAction{
        margin: 30px -40px -30px;
        padding: 10px 20px;
        text-align: right;
        display: flex;
        align-items: center;
        .langSelectorBtn{
          margin-right: auto;
          position: relative;
          border-radius: 50px;
          padding: 6px 16px;
          padding-left: 36px;
          transition: all .3s ease;
          cursor: pointer;
          &:hover{
            background-color: #f5f5fe;
          }
          &:before{
            content: "";
            position: absolute;
            left: 12px; top: 0; bottom: 3px;
            width: 18px;
            background-image: url(../assets/language.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          b{
            font-weight: 600;
            text-transform: uppercase;
          }
          .langSelector{
            position: absolute;
            background-color: #fff;
            z-index: 7;
            bottom: 100%; left: 0;
            box-shadow: 0 0 6px rgba(0, 0, 0, .2);
            border-radius: 5px;
            padding: 8px 0;
            text-align: left;
            li{
              white-space: nowrap;
              list-style: none;
              padding: 8px 24px;
              cursor: pointer;
              transition: all .3s ease;
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        .btn{
          margin-left: 10px;
          &.btnSecondary{
            margin-left: auto;
          }
        }
      }
    }
  }
</style>
